import React, { useState, useEffect } from 'react';
import { Button, Container, Form, Table, Row } from 'react-bootstrap';
import { db, functions } from '../firebase-config';
import { httpsCallable } from 'firebase/functions';
import { collection, getDocs, /*doc, updateDoc*/ } from "firebase/firestore";
// import { useNavigate } from 'react-router-dom';

import { useAuth } from '../Context/AuthContext';
import StatusSpinner from '../Components/StatusSpinner';

import { toast } from 'react-toastify';

// const navigate = useNavigate();

export default function EmployeeAdminSettings() {
  const { showSpinner, setShowSpinner } = useAuth();
  const [userAdminStatusEmail, setUserAdminStatusEmail] = useState('');
  const [listOfAdminEmails, setListOfAdminEmails] = useState([""]);
  const [employeeInfo, setEmployeeInfo] = useState([]);

  useEffect(()=>{
      setShowSpinner(true);
      getDocs(collection(db, "technicians")).then((snapShot)=>{
          let emailList = [""];
          let employeeTempInfo = [];
          snapShot.forEach((doc)=>{
            if(doc.data()?.deleted === undefined || !doc.data()?.deleted){
              emailList.push(doc.data().email);
              employeeTempInfo.push({...doc.data(), id: doc.id});
            }
          });
          return {emailList: emailList, empInfo: employeeTempInfo};
      }).then((info)=>{
          setShowSpinner(false);
          setListOfAdminEmails(info.emailList);
          setEmployeeInfo(info.empInfo);
      }).catch((error)=>{
          setShowSpinner(false);
          toast.error(`Error getting employee email list: ${error.message}`);
      });
  }, [setShowSpinner]);

  const handleCreateAdminClick = ()=>{
    const index = employeeInfo.findIndex((info) => info.email === userAdminStatusEmail);
    setShowSpinner(true);
    const addAdminRole = httpsCallable(functions, "addAdminRole");
    addAdminRole({ email: userAdminStatusEmail }).then((result)=>{
      setShowSpinner(false);
      if(result.data.status === 200){
        let tempEmployeeInfo = [...employeeInfo];
        tempEmployeeInfo[index] = {
          ...tempEmployeeInfo[index],
          'status': 'admin',
        }
        setEmployeeInfo(tempEmployeeInfo);
        toast.success(result.data.message);
        setUserAdminStatusEmail('');
      }else{
        toast.error(result.data.message);
      }
    }).catch((error)=>{
      setShowSpinner(false);
      toast.error(`Error saving ${userAdminStatusEmail} access: ${error.message}`);
    });
  };

  const handleRevokeAdminClick = ()=>{
    const index = employeeInfo.findIndex((info) => info.email === userAdminStatusEmail);
    setShowSpinner(true);
    const revokeAdminRole = httpsCallable(functions, "revokeAdminRole");
    revokeAdminRole({ email: userAdminStatusEmail }).then((result)=>{
      setShowSpinner(false);
      if(result.data.status === 200){
        let tempEmployeeInfo = [...employeeInfo];
        tempEmployeeInfo[index] = {
          ...tempEmployeeInfo[index],
          'status': 'revoked',
        }
        setEmployeeInfo(tempEmployeeInfo);
        toast.success(result.data.message);
        setUserAdminStatusEmail('');
      }else{
        toast.error(result.data.message);
      }
    }).catch((error)=>{
      setShowSpinner(false);
      toast.error(`Error saving ${userAdminStatusEmail} access: ${error.message}`);
    });
  };

  return(
    <>
      <Container fluid style={{width:"100%",paddingLeft:"70px", marginRight:"70px"}}>
          <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
              <Row className="justify-content-center">
                  ADMIN SETTINGS
              </Row>
          </Container>
      </Container>
      <Container fluid className="d-flex align-items-center justify-content-center" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
          <div className="w-100" style={{maxWidth: "600px"}}>
              <div className="mt-5">
                  <Form.Group  style={{textAlign:"left"}} id="admin-set-email">
                      <Form.Label>Email to add/revoke admin status</Form.Label>
                      <Form.Select value={userAdminStatusEmail} onChange={(event)=>{
                          setUserAdminStatusEmail(event.target.value)
                      }}>
                          {
                              listOfAdminEmails.map((email, index)=>{
                                  return(<option key={index} value={email}>{email}</option>)
                              })
                          }
                      </Form.Select>
                  </Form.Group>
              </div>
              {
                  employeeInfo.find(({email}) => email === userAdminStatusEmail)?.status === 'revoked' ?
                      <div className="mt-3">
                        <Button 
                          className="btn-dark"
                          style={{backgroundColor:"#2596be", margin:5}}
                          onClick={handleCreateAdminClick}
                        >
                          Create admin
                        </Button>
                      </div>
                  :
                      employeeInfo.find(({email}) => email === userAdminStatusEmail)?.status === 'admin' ?
                          <div className="mt-3">
                            <Button
                              className="btn-dark"
                              style={{backgroundColor:"#2596be", margin:5}}
                              onClick={handleRevokeAdminClick}
                            >
                              Revoke admin
                            </Button>
                          </div>
                      :
                          ''
              }
          </div>
      </Container>
      <Container fluid className="d-flex align-items-center justify-content-center" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
        <div className="w-100" style={{maxWidth: "600px"}}>
          <div className="mt-5">
            <Table>
              <thead>
                <tr>
                  <th>Employee Name</th>
                  <th>Email</th>
                  <th>Admin Status</th>
                </tr>
              </thead>
              <tbody>
                {
                  employeeInfo.map((employee, index)=>{
                      return(
                        <tr
                          key={index}
                          style={{cursor:"pointer"}}
                          onClick={() => setUserAdminStatusEmail(employee.email)}
                        >
                          <td>{employee?.tech_name}</td>
                          <td>{employee?.email}</td>
                          <td style={{color:
                                  employee?.status === undefined ?
                                      "red" 
                                  :
                                      employee.status === "admin" ?
                                          "green"
                                      :
                                          "red"
                              }}
                          >{employee?.status !== undefined ? employee.status : "revoked"}</td>
                        </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </div>
        </div>
        {
        showSpinner &&
          <StatusSpinner />
        }
      </Container>
    </>
  )
}